export default (state = {}, action) => {
  switch(action.type) {
    case 'OPEN_EDIT_FORM':
      return {
        ...state,
        companyUsersInEditModeIds: [ ...new Set((state.companyUsersInEditModeIds || []).concat(action.id)) ]
      }
    case 'CLOSE_EDIT_FORM':
      return {
        ...state,
        companyUsersInEditModeIds: (state.companyUsersInEditModeIds || []).filter(id => id !== action.id)
      }
    case 'SET_ACTIVE_TAB':
      return {
        ...state,
        activeTab: action.tab,
        hasOpenForm: action.hasOpenForm
      }
    case 'REMOVE_COMPANY_USER':
      return {
        ...state,
        companyUsers: (state.companyUsers || []).filter(cu => cu.id !== action.id)
      }
    case 'UPDATE_COMPANY_USER':
      return {
        ...state,
        companyUsersInEditModeIds: (state.companyUsersInEditModeIds || []).filter(id => id !== action.props.id),
        companyUsers: (state.companyUsers || []).map(cu => (cu.id === action.props.id) ? action.props : cu)
      }
    case 'OPEN_USER_INVITATION_FORM':
      return { ...state, hasOpenForm: true }
    case 'CLOSE_USER_INVITATION_FORM':
      return { ...state, hasOpenForm: false }
    case 'ADD_USER_INVITATION':
      return {
        ...state,
        hasOpenForm: false,
        invitations: [action.invitation].concat(state.invitations || [])
      }
    case 'UPDATE_USER_INVITATION':
      return {
        ...state,
        invitations: (state.invitations || []).map(inv => inv.id === action.invitation.id ? action.invitation : inv)
      }
    case 'DELETE_USER_INVITATION':
      return {
        ...state,
        invitations: (state.invitations || []).filter(inv => inv.id !== action.id)
      }
    case 'DELETE_CONTACT':
      console.log('we are here', state.contacts, action.id)
      return {
        ...state,
        contacts: (state.contacts || []).filter(contact => contact.id !== action.id)
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./app/javascript/reactFeatures/company-users/reducers/companyUsers.js